import React, { useEffect, useState } from "react";
import { Row, Col, ListGroup, ListGroupItem, Label, Button } from "reactstrap";
import moment from "moment";

import appointmentService from "../../services/appointmentService";
import AppointmentListItems from "./AppointmentListItems";

const AvailableAppointments = () => {
  const [dateTimes, setDateTimes] = useState([]);
  const [dates, setDates] = useState([]);
  const [active, setActive] = useState("");
  const [currentDate, setCurrentDate] = useState({
    month: moment().month() + 1,
    year: moment().year(),
  });

  useEffect(() => {
    appointmentService
      .getAppointmentsByMonthAtt(currentDate)
      .then((payload) => {
        //console.log(payload);
        setDateTimes(payload.appointments);
        setDates(payload.dates);
        setActive(payload.dates[0]);
      });
  }, [currentDate]);

  useEffect(() => {
    appointmentService
      .getAppointmentsByMonthAtt(currentDate)
      .then((payload) => {
        //console.log(payload);
        setDateTimes(payload.appointments);
        setDates(payload.dates);
        setActive(payload.dates[0]);
      });
  }, [currentDate]);

  const filterArray = () => {
    const filterDate = active;
    const filteredArray = dateTimes.filter((dateTime) => {
      return moment(dateTime.timeSlotStart).isSame(moment(filterDate), "day");
    });
    return filteredArray;
  };

  const monthPrior = () => {
    if (currentDate.month === 1) {
      return setCurrentDate({
        ...currentDate,
        month: 12,
        year: currentDate.year - 1,
      });
    }
    return setCurrentDate({ ...currentDate, month: currentDate.month - 1 });
  };

  const monthAfter = () => {
    if (currentDate.month === 12) {
      return setCurrentDate({
        ...currentDate,
        month: 1,
        year: currentDate.year + 1,
      });
    }
    return setCurrentDate({ ...currentDate, month: currentDate.month + 1 });
  };

  const refreshMonth = () => {
    appointmentService
      .getAppointmentsByMonthAtt(currentDate)
      .then((payload) => {
        //console.log(payload);
        setDateTimes(payload.appointments);
        setDates(payload.dates);
      });
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h2>Available appointments</h2>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <Label>Dates</Label>
          <Row style={{ paddingBottom: "10px" }}>
            <Col>
              <Button
                type="button"
                className="btn-sm"
                outline
                color="primary"
                onClick={() => monthPrior()}
              >
                &lt;
              </Button>
            </Col>
            <Col xs={7}>
              <span>
                <b>
                  {moment(
                    currentDate.month, // Desired month
                    "MM" // Tells MomentJs the number is a reference to month
                  ).format("MMMM") // Formats month as name
                  }{" "}
                  {currentDate.year}
                </b>
              </span>
            </Col>
            <Col>
              <Button
                type="button btn-sm"
                className="btn-sm"
                outline
                color="primary"
                onClick={() => monthAfter()}
              >
                &gt;
              </Button>
            </Col>
          </Row>
          <ListGroup>
            {dates.map((date) => (
              <ListGroupItem
                tag="button"
                active={active === date ? true : false}
                onClick={() => setActive(date)}
                action
                key={date}
              >
                {date}
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
        <Col md={9}>
          {active !== "" && (
            <AppointmentListItems
              date={active}
              dateTimes={filterArray()}
              refreshMonth={refreshMonth}
            />
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AvailableAppointments;
